import React from 'react';
import { Chip } from '@mui/material';
import { STATUS_COLORS } from '../../config/statusConfig';

/**
 * StatusChip Component
 * Displays status as a colored chip based on status configuration
 * Compact, professional chip design
 */
const StatusChip = ({ status, variant = 'filled' }) => {
  const color = STATUS_COLORS[status] || 'default';
  
  return (
    <Chip 
      label={status} 
      color={color} 
      variant={variant}
      size="small"
      sx={{
        height: 22,
        fontSize: '0.75rem',
        fontWeight: 500,
        '&.MuiChip-colorDefault': {
          backgroundColor: '#e5e7eb',
          color: '#6b7280',
        },
        '&.MuiChip-colorPrimary': {
          backgroundColor: '#dbeafe',
          color: '#1e40af',
        },
        '&.MuiChip-colorSuccess': {
          backgroundColor: '#d1fae5',
          color: '#065f46',
        },
        '&.MuiChip-colorWarning': {
          backgroundColor: '#fef3c7',
          color: '#3e3e3e',
        },
        '&.MuiChip-colorError': {
          backgroundColor: '#fee2e2',
          color: '#991b1b',
        },
      }}
    />
  );
};

export default StatusChip;
